import { styled, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * CleanButton - A minimalist button with subtle hover effects
 *
 * Provides consistent button styling across the app with theme-aware colors.
 * Supports both outlined (default) and contained variants.
 *
 * @see src/modules/TeamModule/components/TeamsV2Page.tsx
 * @see src/modules/ReportsModule/TeamsOverviewPage.tsx
 */
export const CleanButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '0.875rem',
  padding: theme.spacing(1, 2.5),
  borderRadius: theme.spacing(2), // 8px
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
  background: 'transparent',
  transition: 'all 0.15s ease',
  '&:hover': {
    background: theme.palette.action.hover,
    borderColor: theme.palette.action.disabled,
  },
  '&.MuiButton-contained': {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    border: 'none',
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
}));
